export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_CLIENT_ID!, 
      authority:process.env.REACT_APP_MSAL_AUTHORITY!, 
      redirectUri: window.location.origin, 
      knownAuthorities: [process.env.REACT_APP_KNOWN_AUTHORITY!]
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true, 
    },    
  };
  
  export const loginRequest = {
   scopes: [process.env.REACT_APP_SCOPE!] // Scopes you need for access
  };
  
  export const apiRequest = {
    scopes: [process.env.REACT_APP_SCOPE!], 
  };

export function waitForNativeConfig(): Promise<any> {
  return new Promise(resolve => {
    const check = () => {
      if ((window as any).NativeConfig) {
        resolve((window as any).NativeConfig);
      } else {
        setTimeout(check, 20); // retry every 20ms
      }
    };
    check();
  });
}


export const loadConfig = async () => {
  const nativeConfig = await waitForNativeConfig();  // waits until injected

  const env = nativeConfig.selectedEnv;
  const cfg = nativeConfig.environments[env];

  return {
    msalPWAConfig: cfg.msalPWAConfig,
    mobileBaseURL: cfg.mobileBaseURL,
    clientcode: cfg.clientcode,
  };
};

loadConfig().then(config => {
  console.log("Config Loaded");
});



